module.exports = __webpack_public_path__ + "img/党内法规.bed63483.png";